import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';
// Modules
import ecommerceStoreModule from '@/views/apps/e-commerce/eCommerceStoreModule'
import app from './app'
import appConfig from './app-config'
import auth from './auth'
import verticalMenu from './vertical-menu'
import eInvoiceManagement from './e-invoice-management';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    auth,
    verticalMenu,
    eInvoiceManagement,
    'app-ecommerce': ecommerceStoreModule,
  },
  strict: process.env.DEV,
  plugins: [createPersistedState()],
  state: { loading: false },
  mutations: {
    setLoading(state, status) {
      state.loading = status;
    },
    getLoading(state) {
      return state.loading;
    }
  }
})
